module.exports = __webpack_public_path__ + "static/media/new_pack_dog_EN_768x350.b15fd8e2.png";